export default __webpack_public_path__ + "static/media/minus.769620b0.svg";